import type { InputHTMLAttributes } from 'preact';
import { cn } from '../../lib/utils';

/**
 * Champ de saisie — anatomie shadcn/ui, jetons SYGAP.
 *
 * La bordure emploie `border-input`, nettement plus marquée que le gris de
 * l'amont : WCAG 1.4.11 impose 3:1 à la limite qui **identifie une commande**,
 * et le défaut de shadcn plafonne autour de 1,6:1. Sur un écran délavé en plein
 * soleil, la différence n'est pas théorique — un champ dont on ne voit pas le
 * bord ne se remplit pas.
 */
export function Input({ className, type, ...reste }: InputHTMLAttributes) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'flex h-10 w-full min-w-0 rounded-xl border border-input bg-card px-3 py-1 text-base shadow-none outline-none transition-colors',
        'placeholder:text-muted-foreground',
        'file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground',
        'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/25',
        'aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive/25',
        'disabled:cursor-not-allowed disabled:opacity-50',
        // 16 px sur mobile : en dessous, iOS zoome à la mise au point et
        // décadre le formulaire. La densité du poste agent reprend à `sm`.
        'md:text-sm',
        className,
      )}
      {...reste}
    />
  );
}
